import React from 'react';
import { Switch, Route } from 'react-router-dom';
import List from './credentials/List';
import Show from './credentials/Show';
import Editor from './credentials/Editor';
import { CheckReadiness } from './migrations/CheckReadiness';
import { MigrationStatus } from './migrations/Status';

const AdminCredential = () => (
  <Switch>
    <Route component={List} exact path="/admin/credentials" />
    <Route
      exact
      path="/admin/credentials/new"
      render={(props) => <Editor key={props.location.pathname} isNew={true} />}
    />
    <Route component={CheckReadiness} exact path="/admin/credentials/migrations" />
    <Route
      exact
      path="/admin/credentials/migrations/:id"
      render={(props) => <MigrationStatus migrationId={props.match.params.id} />}
    />
    <Route
      exact
      path="/admin/credentials/:id/edit"
      render={(props) => (
        <Editor key={props.location.pathname} credentialId={props.match.params.id} isNew={false} />
      )}
    />
    <Route
      exact
      path="/admin/credentials/:id"
      render={(props) => <Show credentialId={props.match.params.id} />}
    />
  </Switch>
);

export default AdminCredential;
